import {Carousel} from 'antd';
import React from 'react';
import './CustomCarousel.less';

const CustomCarousel = ({items}: any) => {
	return (
		<div className="carousel">
			<div className="carousel__container">
				<div className="carousel__content">
					<Carousel dots={true} arrows /* autoplay */ draggable autoplaySpeed={3000}>
						{items?.map((elem: any, index: number) => {
							return (
								<div
									className={'carousel__item'}
									key={index}
									// style={{width: '540px', height: '340px'}}
								>
									{elem}
								</div>
							);
						})}
					</Carousel>
				</div>
			</div>
		</div>
	);
};

export default CustomCarousel;
